import '../../../toggleable_html_editor_view.js.coffee'

class Customer.SignatureEditorView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/signatures/editor"]
  blank_model: Backbone.Model.extend({})

  modal:
    title: 'Edit signature',
    buttons: [
      {
        title: 'Save signature',
        event: 'save'
      },
      {
        title: 'Cancel',
        event: 'exit'
      },
    ]

  initialize: (@options = {}) ->
    @isNew = @options.new
    @model = @options.model
    @modal.title = I18n.t('monitoring.user_settings.signatures.create') if @isNew
    @modal.buttons[0].title = I18n.t('monitoring.user_settings.signatures.save')
    @modal.buttons[1].title = I18n.t('monitoring.user_settings.signatures.cancel')
    @createModal = !@options.modalView
    @render()
    @modalInitialize()
    @initializeTooltips()

  render: ->
    @$el.html(@template({self: @}))
    @activeButton = @$el.find('#active-button')
    @activeButton.bootstrapToggle({width: 80, height: 20});
    @_renderAppendToResponseButton()
    @_addTypes()
    @_addLabels()
    @_renderAppendToNewTicketView()
    @_renderAppropiateTextArea()

  modalInitialize: () ->
    if @createModal
      @modalView = new App.ModalView({instance: @, wide: true})
      @modalTab = @modalView.firstTab
    else
      @modalTab = @options.modalView.add(@, true)

  initializeTooltips: ->
    $('[data-toggle=tooltip]').tooltip()

  exit: =>
    if (not @isNew)
      @modalTab.removeModal();
    else
      @modalTab.remove();
    @signatureTextContainer.html('')
    @remove();

  save: =>
    if @validate()
      @saveToServer()

  validate: =>
    text = @_getText()
    if @textMaximumLengthReached(text.plain)
      showError("Signature content exceeds the maximum length allowed")
      return
    if _.string.isBlank(text.plain)
      @validateTypes()
      @signatureTextContainer.addClass('error');
      return false
    else
      @signatureTextContainer.removeClass('error');

    return @validateTypes()
    
  validateTypes: =>
    if @TypesView.toArray().length == 0
      @$el.find(".chosen-container.chosen-container-single").addClass('error')
      return false
    else
      @$el.find(".chosen-container.chosen-container-single").removeClass('error')
      return true

  textMaximumLengthReached: (text) =>
    if "email" in @TypesView.toDescriptionArray()
      return text.length > 2000
    else
      return text.length > 254

  activate: =>
    @modalTab._activate()

  saveToServer: ->
    params = @_serialize()
    url = "/signatures/create_or_update"

    $.post(url, params, (response) =>
      if response.success
        @exit()
        params['id'] = response.signature_id
        if @isNew
          @options.caller.appendNewSignature(params)
        else
          @options.caller.updateSignature(params)
      else
        showError(response.error);
    )

  _renderAppendToResponseButton: ->
    @appendToResponseButton = @$el.find('#append-to-response')
    @appendToResponseButton.bootstrapToggle({width: 80, height: 20})

  _addTypes: ->
    types = @options.types
    selected_ids = @options.model.types.map (i) -> i.original_type_id
    is_email = @options.model.types.some (type) -> type.name == 'email'
    emailType = _.find(types, (type) -> type.name is 'email')
    if emailType
      @TypesView = new App.LonelyOptionSelectView(
        selectedOptions: selected_ids
        options: _.reject(types, (type) -> type.name is 'email')
        editable: !is_email
        lonely: emailType
        valueProperty: 'id'
        descriptionProperty: 'name'
        placeholder: I18n.t('monitoring.user_settings.predefined_templates.type.add_a_type')
        width: "100%"
      )
      @listenTo(@TypesView, "selection:lonely:error", @_emailTypeSelectionError)
    else
      @TypesView = new App.AllSelectView(
        selectedOptions: selected_ids
        options: types
        editable: true
        valueProperty: 'id'
        descriptionProperty: 'name'
        placeholder: I18n.t('monitoring.user_settings.predefined_templates.type.add_a_type')
        width: "100%"
      )
    @listenTo(@TypesView, 'change', => @textEditor.toggleMode(@_getEditorMode()))
    @listenTo(@TypesView, 'change', @_renderAppendToNewTicketView)
    @$el.find('#types').append(@TypesView.el)

  _addLabels: ->
    selected_ids = this.options.model.labels.map (i) -> i.original_label_id
    @LabelsView = new App.AllSelectView(
      selectedOptions: selected_ids
      options: @options.labels
      valueProperty: 'id'
      descriptionProperty: 'name'
      placeholder: I18n.t('monitoring.user_settings.predefined_templates.add_a_group')
      width: "100%"
    )
    @$el.find('#labels').append(@LabelsView.el)

  _renderAppendToNewTicketView: ->
    if 'email' in @TypesView.toDescriptionArray()
      @appendToNewTicketView = new Customer.SignatureAppendToNewTicketView({model: @model})
      @$el.find('#append-to-new-ticket-container').append(@appendToNewTicketView.render().el)
    else
      @appendToNewTicketView.remove() if @appendToNewTicketView

  _renderAppropiateTextArea: =>
    @signatureTextContainer = @$el.find('#signature-text')
    text = @_getText()
    mode = @_getEditorMode()
    @textEditor = new ToggleableHTMLEditorView(mode: mode, textLimit: 255, boxSize: 2)
    @signatureTextContainer.html(@textEditor.render(
      if mode == 'html' then text.enriched else text.plain
    ).el)

  _emailTypeSelectionError: =>
    swal({
      title: I18n.t('monitoring.user_settings.signatures.type_error.title'),
      text: I18n.t('monitoring.user_settings.signatures.type_error.text'),
      type: "info",
      showCancelButton: false,
      confirmButtonClass: 'btn-info',
      confirmButtonText: 'Ok',
      closeOnConfirm: true
    })

  _getText: ->
    if @textEditor
      plain: @textEditor.getPlainText()
      enriched: @textEditor.getPlainHTML()
    else
      plain: @options.model.text
      enriched: @options.model.text_html

  _getEditorMode: =>
    return 'html' if 'email' in @TypesView.toDescriptionArray()
    'plain'

  _truncateText: (text) ->
    return text unless text.length > 254
    text.substring(0,251) + "..."

  _serialize: ->
    results = {}
    results['active'] = @activeButton.prop("checked")
    results['append_to_new_ticket'] = @appendToNewTicketView?.getValue()
    results['append_to_response'] = @appendToResponseButton.prop('checked')
    results['types_ids'] = @TypesView.toArray()
    results['labels_ids'] = @LabelsView.toArray()
    types = []
    labels = []
    i = 0
    for type in @TypesView.toDescriptionArray()
      types.push({name: type, original_type_id: results['types_ids'][i]})
      i++
    i = 0
    for label in @LabelsView.toDescriptionArray()
      labels.push({name: label, original_label_id: results['labels_ids'][i]})
      i++
    results['types'] = types
    results['labels'] = labels
    textValues = @_getText()
    results['text'] = @_truncateText(textValues.plain)
    results['text_html'] = textValues.enriched
    results['id'] = this.options.model.id if not @isNew
    results
